import React, {Component} from 'react';
import './styles.css';

interface Props {
    id?: string;
}

class Panel extends Component<Props> {
    public render(): JSX.Element {
        return (
            <div id={this.props.id} className="Panel">
                {this.props.children}
            </div>
        );
    }
}

export default Panel;



// WEBPACK FOOTER //
// ./src/Panel/index.tsx